// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-Content-module--cls1--2W4wC","cls2":"index-Content-module--cls2--2s0C3 index-Content-module--cls1--2W4wC px-4"};